<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    :width="width"
    :modal-append-to-body="modalAppendToBody"
    :close-on-click-modal="closeOnClickModal"
    :lock-scroll="lockScroll"
    :close-on-press-escape="closeOnPressEscape"
    :append-to-body="appendToBody"
    :destroy-on-close="destroyOnClose"
    custom-class="dialogStyle"
    @close="close">
    <slot v-if="visible"/>
  </el-dialog>
</template>

<script type="text/javascript">
export default {
  props: {
    title: {
      type:String,
      default:'提示'
    },
    width: {
      type:String,
      default:'50%'
    },
    modalAppendToBody:{
      type:Boolean,
      default:false
    },
    closeOnClickModal:{
      type:Boolean,
      default:false
    },
    lockScroll:{
      type:Boolean,
      default:false
    },
    closeOnPressEscape:{
      type:Boolean,
      default:false
    },
    destroyOnClose:{
      type:Boolean,
      default:true
    },
    top:{
      type:String,
      default:'15vh'
    },
    appendToBody:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
.dialogStyle{
  z-index: 3000;
  margin-bottom: 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/dialog/dialog.vue